export const EMAIL_REGEX = /^\S+@\S+\.\S+$/
export const CELL_CODE_REGEX = /^\+[0-9][0-9]+$/
